import { Model, OptionModel } from "services/models/model";
import { IModel } from "./../IModel";
import { ObjectMapper } from "json-object-mapper";

export class WorkLeaveTypeModel
  extends Model
  implements IModel<WorkLeaveTypeModel> {
  code: string = "";
  description: string = "";

  static create(input: any): WorkLeaveTypeModel {
    return ObjectMapper.deserialize<WorkLeaveTypeModel>(
      WorkLeaveTypeModel,
      input
    );
  }

  toOption(): OptionModel {
    return {
      label: `${this["code"]} - ${this["description"]}`,
      value: this.id,
    } as OptionModel;
  }
}
